import { useState } from 'react';
import Modal from '../../../components/layout/Modal';
import { SecondaryButton } from '../../../components/ui/buttons';
import { useTags } from '../../../hooks/api/tags/useTags';
import Divider from '../../../components/divider/Divider';
import { InfoCircle } from '@boxicons/react';

export default function TagInfoModal() {
    const [visible, setVisible] = useState(false);

    const { data } = useTags();

    function openModal() {
        setVisible(true);
    }

    return (
        <>
            <button className='self-center' onClick={openModal}>
                <InfoCircle />{' '}
            </button>
            <Modal title='Skillset explanation' show={visible} onClose={() => setVisible(false)}>
                <div>
                    <p>Tags describe the general skillsets that are present in this level.</p>
                    <p>You may vote on tags once you have an approved submission for this level.</p>
                    <Divider />
                    <div>
                        <ul>
                            {data?.map((t) => (
                                <li className='mb-3' key={t.ID}>
                                    <h5 className='text-lg font-bold'>{t.Name}</h5>
                                    <p className='text-base'>{t.Description}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className='flex round:gap-1 float-right mb-4'>
                    <SecondaryButton onClick={() => setVisible(false)}>Close</SecondaryButton>
                </div>
            </Modal>
        </>
    );
}
